
module.exports =  require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/engine.io-client/index.js
 ** module id = 683
 ** module chunks = 0 5
 **/